module.exports = __webpack_public_path__ + "img/ski_besttourplace.4e0be9c4.png";